import React, { createContext, useContext, useState, useCallback } from "react";

const WaitlistContext = createContext(null);

export const useWaitlist = () => {
  const ctx = useContext(WaitlistContext);
  if (!ctx) throw new Error("useWaitlist must be used within WaitlistProvider");
  return ctx;
};

export const WaitlistProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [source, setSource] = useState("cta");
  const openWaitlist = useCallback((src = "cta") => {
    setSource(src);
    setOpen(true);
  }, []);
  return (
    <WaitlistContext.Provider value={{ open, setOpen, openWaitlist, source }}>
      {children}
    </WaitlistContext.Provider>
  );
};
